import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SalesReturnLine, SalesReturnLineCreate, SalesReturnLineFilter } from '../data/salesReturnLine';

export function createSalesReturnLineService(client: AxiosInstance) {
  return createCrudService<SalesReturnLine, SalesReturnLineCreate, SalesReturnLineFilter>(
    client,
    '/sales/SalesReturnLine',
    'id',
  );
}

export type SalesReturnLineService = CrudService<SalesReturnLine, SalesReturnLineCreate, SalesReturnLineFilter>;
